import { useTranslation } from "@flare/i18n";

import { TextArea } from "@/components/Funnel/text-area";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { SkipButton } from "../components/skip-button";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

import type { StepProps } from "./step.types";

export default function MoreInfo({ answers, handlers }: StepProps) {
  const { t } = useTranslation();
  const { onSkip } = handlers;
  const { practice } = answers;
  const inputPlaceholder =
    practice === "immigration"
      ? t("FUNNEL_MORE_INFO_IMMIGRATION_PLACEHOLDER")
      : t("FUNNEL_MORE_INFO_FAMILY_PLACEHOLDER");

  return (
    <>
      <StepContainer>
        <StepContent>
          <div className="flex items-start justify-between gap-sp-2">
            <BackButton />
            <SkipButton onSkip={onSkip}>
              {t("FUNNEL_MORE_INFO_SKIP")}
            </SkipButton>
          </div>
          <StepTitle>{t("FUNNEL_MORE_INFO_TITLE")}</StepTitle>

          <div className="mx-auto mt-sp-8 max-w-[520px]">
            <TextArea
              name={funnelInputsNameMap.moreInfo}
              placeholder={inputPlaceholder}
            />
          </div>
        </StepContent>
        <ActionsContainer onSkip={onSkip}>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
